import { TRootState } from '../../common/reducers';
import { renderModel } from '../../util/renderModel';

const isFullWidth = renderModel.isFullWidth();

export type KbWidgetState = 'full_page_extended' | 'full_page_opened';

export function getKbWidgetState(state: TRootState): KbWidgetState | undefined {
  if (!isFullWidth) {
    return undefined;
  }

  const { fullPageSidebarExtended, fullPageSidebarOpened } = state.helpCenter;

  if (fullPageSidebarExtended) {
    return 'full_page_extended';
  }

  if (fullPageSidebarOpened) {
    return 'full_page_opened';
  }
}
